import Icon from "@lib/common/components/Icon/Icon";
import { ActionIcon, Group, Paper, Text, Tooltip } from "@mantine/core";

export type ChatAttachmentChipItem = {
  key: string;
  filename: string;
};

export default function ChatAttachmentChips({
  items,
  onRemove
}: {
  items: ChatAttachmentChipItem[];
  onRemove?: (key: string) => void;
}) {
  if (items.length === 0) {
    return null;
  }
  return (
    <Group gap="xs" wrap="wrap" mt={5}>
      {items.map(item => (
        <Paper
          key={item.key}
          variant="light"
          color="gray"
          pl="xs"
          pr={3}
          py={3}
          bg="var(--mantine-color-gray-light)"
          radius="md"
          shadow="xxs"
        >
          <Group justify="space-between" gap="xs">
            <Group gap="xs">
              <Icon name="paperclip" size="0.8rem" variant="solid" color="red" />
              <Text size="xs" fw={500}>
                {item.filename}
              </Text>
            </Group>

            {typeof onRemove === "function" && (
              <Tooltip label="Remove attachment">
                <ActionIcon size="sm" variant="subtle" color="gray" radius="md" onClick={() => onRemove(item.key)}>
                  <Icon name="xmark" size="0.8rem" variant="solid" />
                </ActionIcon>
              </Tooltip>
            )}
          </Group>
        </Paper>
      ))}
    </Group>
  );
}
